var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 130,
  height: 100,
  fill: "none",
  viewBox: "0 0 130 100"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF4858",
  d: "M40.017 90.834C67.67 70.675 87.78 39.618 95.889 4.61c.362-1.555-.153-3.057-1.197-3.354-1.02-.284-2.144.7-2.509 2.192-3.952 17.035-10.828 33.146-20.066 47.444-9.263 14.284-20.924 26.767-34.358 36.576-1.184.877-1.658 2.342-1.058 3.295s2.087.984 3.316.07"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF4858",
  d: "M36.417 72.367c-.396 3.08-.92 6.141-1.583 9.144a133 133 0 0 1-1.088 4.495l-.756 2.69-1.399 4.518 19.692-.158c.515-.01.87-.916.773-2.026s-.58-2.019-1.096-2.008l-14.08.122.518-1.849c.404-1.549.79-3.092 1.146-4.666a110 110 0 0 0 1.65-9.514c.06-.561-.716-1.17-1.754-1.34s-1.944.089-1.998.605z"
})));
export default SvgArrow;